/**
 * KpiCard — small KPI tile for the admin dashboard.
 */
export const KpiCard = ({ label, value, hint, accent = "bg-roseMilk", testId, onClick }) => {
  const inner = (
    <>
      <p className="wit-eyebrow text-warmGrey">{label}</p>
      <p className="font-serif text-4xl text-cocoa mt-2">{value}</p>
      {hint && <p className="text-xs text-warmGrey mt-2 leading-relaxed">{hint}</p>}
    </>
  );
  const base =
    "block w-full text-left bg-white border border-sandBeige rounded-3xl p-6 transition-shadow hover:shadow-soft";
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={base} data-testid={testId}>
        <div className={`inline-block w-8 h-2 rounded-full ${accent} mb-3`} />
        {inner}
      </button>
    );
  }
  return (
    <div className={base} data-testid={testId}>
      <div className={`inline-block w-8 h-2 rounded-full ${accent} mb-3`} />
      {inner}
    </div>
  );
};

export default KpiCard;
